// Finance API client — SHIP B.6 wrapper around `POST /api/finance/calculate`.
//
// The Listing Detail Page renders an embedded calculator that pings
// this on every slider change (debounced). The `client` already prefixes
// `/api`, so the path is relative.
import { apiClient } from "./client";

export async function calculateFinance(payload) {
  const r = await apiClient.post("/finance/calculate", payload);
  return r.data;
}

// V4.22 — central country finance config (fees, DE Bundesländer, defaults).
export async function getFinanceConfig(country, postalCode) {
  const params = { country };
  if (postalCode) params.postal_code = postalCode;
  const r = await apiClient.get("/finance/config", { params });
  return r.data;
}
